import { captureException } from '@sentry/nextjs';
import { AxiosError } from 'axios';

export const LogError = (error: AxiosError) => {
  captureException(error, {
    tags: {
      location: 'axiosClient',
      status: error.status || 'unknown',
    },
    extra: {
      url: error.config?.url,
      method: error.config?.method,
      requestData: error.config?.data,
      responseData: error.response?.data,
      errorMessage: error.message,
      requestParams: error.config?.params,
    },
  });
};
